import React from 'react';

import TomatoRunning from './TomatoRunning';
import TomatoTaskList from './TomatoTaskList';

export default () => (
  <div className="row" style={{height: '100%', margin: 0}}>
    <div 
      className="col-sm"
      style={{height: '100%', display: 'flex', flexDirection: 'column', padding: 0, }}
    >
      <div>
        <TomatoRunning />
      </div>
      <div style={{height: '100%', marginTop: 20}}>
        <TomatoTaskList />
      </div>
    </div>
 
  </div>
)


// WEBPACK FOOTER //
// ./src/navigation/Tomato/index.js